import { clearLastSearch, getLastViewedEstab, getLastSearch, clearLastViewedEstab, TripType, DateSearchType, } from '@honeycomb/data';
import { getDetailsPageUrl } from '@honeycomb/routing';
import { getDateSummary } from './getDateSummary';
import { getSelectedOptionSummary } from './getSelectedOptionSummary';
import { getDayDiff } from './date-utils';
// Function to extract SingleAirport entries
const extractSingleAirports = (airports) => {
    const singleAirports = [];
    airports.forEach((airportGroup) => {
        if (airportGroup.__typename === 'SingleAirport') {
            singleAirports.push({
                code: airportGroup.code,
                title: airportGroup.title,
                country: airportGroup.country,
            });
        }
        else if (airportGroup.__typename === 'AirportGroup' && airportGroup.subAirports) {
            airportGroup.subAirports.forEach((subAirport) => {
                if (subAirport) {
                    singleAirports.push({
                        code: subAirport.code,
                        title: subAirport.title,
                        country: subAirport.country,
                    });
                }
            });
        }
    });
    if (singleAirports.length) {
        const uniqueSet = new Set(singleAirports.map((airport) => JSON.stringify(airport)));
        return Array.from(uniqueSet).map((entry) => JSON.parse(entry));
    }
    return singleAirports;
};
function getFlightDetails(param, airports) {
    var _a;
    if (param.tripType === TripType.Holiday && ((_a = param.departureAirports) === null || _a === void 0 ? void 0 : _a.length) && airports) {
        const airportList = extractSingleAirports(airports);
        const selectedAirport = airportList.filter((airport) => { var _a; return (_a = param.departureAirports) === null || _a === void 0 ? void 0 : _a.includes(airport.code); });
        return getSelectedOptionSummary(selectedAirport);
    }
    return '';
}
function getDestinationDeatils(param) {
    var _a, _b, _c, _d, _e;
    if (param.tripType === TripType.Hotel) {
        if ((_a = param.destinations) === null || _a === void 0 ? void 0 : _a.length) {
            const title = (_c = (_b = param.destinations[0]) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : '';
            const count = (_d = param.destinations) === null || _d === void 0 ? void 0 : _d.length;
            return count > 1 ? `${title} (+${count - 1} others)` : title;
        }
        return (_e = param.destinationTitle) !== null && _e !== void 0 ? _e : '';
    }
    return '';
}
export function mapDetails(estab, searchParam, airports) {
    var _a, _b, _c, _d;
    const param = searchParam;
    param.tripStateId = estab.tripStateId;
    const detailsPageUrl = getDetailsPageUrl(param, estab.estabId);
    const isMonthSearch = param.dateSearchType === DateSearchType.ChooseMonth;
    const data = {
        hotelName: estab.name,
        rating: estab.starRating,
        travelDate: getDateSummary(new Date(isMonthSearch ? (_a = param.wholeMonthStartDate) !== null && _a !== void 0 ? _a : '' : param.startDate), new Date(isMonthSearch ? (_b = param.wholeMonthEndDate) !== null && _b !== void 0 ? _b : '' : param.endDate), true),
        hotelImageUrl: `${estab.imageUrl}?width=89&height=85&crop=true&quality=80`,
        detailsPageHref: detailsPageUrl,
        flightDetails: getFlightDetails(param, airports),
        tripType: (_c = param.tripType) !== null && _c !== void 0 ? _c : TripType.Hotel,
        destinationDetails: (_d = getDestinationDeatils(param)) !== null && _d !== void 0 ? _d : '',
    };
    return data;
}
export function useStoredRecentViewed(airportData) {
    var _a;
    let data = null;
    const estabData = getLastViewedEstab();
    const searchData = getLastSearch();
    const clearRecentViewStorage = () => {
        clearLastSearch();
        clearLastViewedEstab();
        data = null;
    };
    if (estabData && !searchData)
        clearLastViewedEstab();
    if (estabData && searchData) {
        const estabDetails = JSON.parse(estabData);
        const searchDetails = JSON.parse(searchData);
        if (getDayDiff(new Date().toISOString(), searchDetails.startDate) > 0 ||
            getDayDiff(new Date().toISOString(), (_a = searchDetails.wholeMonthEndDate) !== null && _a !== void 0 ? _a : '') > 0) {
            data = mapDetails(estabDetails, searchDetails, airportData === null || airportData === void 0 ? void 0 : airportData.airports);
        }
        else {
            clearRecentViewStorage();
        }
    }
    return [data, clearRecentViewStorage];
}
